<template>
  <div class="company-addItem">
    <div class="steps">
      <div class="title">
        <i class="icon icon-caidangongneng"></i>
        <span v-if="!edit">{{ $t('crm_company_item.xzfwgs') }}</span>
        <span v-else>{{ $t('crm_company_item.bjfwgs') }}</span>
      </div>
      <t-step v-model="tabActive" :list="stepList" @change="changeStep"></t-step>
    </div>
    <div class="warpper">
      <!--基础-->
      <company-item-info
        v-if="tabActive === 1 && !funcView.partner_company_simple"
        :partnerId="partnerId"
        :propsFuncView="funcView"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></company-item-info>
      <company-item-info-us
        v-if="tabActive === 1 && funcView.partner_company_simple"
        :partnerId="partnerId"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></company-item-info-us>
      <!--服务区域-->
      <company-item-serviceArea v-if="tabActive === 2" :partnerId="partnerId" :partnerOrgId="partnerOrgId" @success="nextStep" @previous="previous"></company-item-serviceArea>
      <!--联系人-->
      <company-item-contacts
        v-if="tabActive === 3"
        :partnerId="partnerId"
        :partnerOrgId="partnerOrgId"
        :required="!funcView.partner_company_simple"
        @success="nextStep"
        @previous="previous"
      ></company-item-contacts>
      <!-- 管理员信息 -->
      <company-item-administrators v-if="tabActive === 4" :partnerId="partnerId" @success="nextStep" @jumpOut="jumpOut" @previous="previous"></company-item-administrators>
    </div>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import companyItemAdministrators from '@/pages/crm/components/partnerCommon/partner_item_administrators.vue';
import companyItemInfo from './company_item_info.vue';
import companyItemInfoUs from './company_item_info_us.vue';
import companyItemServiceArea from './company_item_serviceArea.vue';
import companyItemContacts from './company_item_contacts.vue';

export default {
  name: 'company_item',
  components: { tStep, companyItemInfo, companyItemServiceArea, companyItemContacts, companyItemAdministrators, companyItemInfoUs },
  computed: {
    stepList() {
      const stepList = [];
      if (this.funcView.partner_company_simple) {
        stepList.push({
          label: 1,
          value: 1,
          title: this.$t('crm_company_item.ji_ben_xin_xi'),
          subTitle: this.$t('crm_company_item.fwgsjbxxtx'),
        });
        stepList.push({
          label: 2,
          value: 3,
          title: this.$t('crm_company_item.lian_xi_ren'),
          subTitle: this.$t('crm_company_item.fwgslxrgl'),
        });
        stepList.push({
          label: 3,
          value: 4,
          title: this.$t('crm_company_item.guan_li_yuan_xin_xi'),
          subTitle: this.$t('crm_company_item.ptglyxxgl'),
        });
      } else {
        stepList.push({
          label: 1,
          value: 1,
          title: this.$t('crm_company_item.ji_ben_xin_xi'),
          subTitle: this.$t('crm_company_item.fwgsjbxxtx'),
        });
        stepList.push({
          label: 2,
          value: 2,
          title: this.$t('crm_company_item.fu_wu_qu_yu'),
          subTitle: this.$t('crm_company_item.fwgsfwqysz'),
        });
        stepList.push({
          label: 3,
          value: 3,
          title: this.$t('crm_company_item.lian_xi_ren'),
          subTitle: this.$t('crm_company_item.fwgslxrgl'),
        });
        stepList.push({
          label: 4,
          value: 4,
          title: this.$t('crm_company_item.guan_li_yuan_xin_xi'),
          subTitle: this.$t('crm_company_item.ptglyxxgl'),
        });
      }
      return stepList;
    }
  },
  data() {
    return {
      tabActive: 1,

      partnerId: '',
      partnerOrgId: '',
      edit: false,
      // 第一步的数据用来共享
      infoForm: {},
    };
  },
  mounted() {
    this.getFuncView('/distributor/serviceCompany', () => {
      // stepList 现在是计算属性，会自动根据 funcView 变化
    });

    // 获取id   有去获取详情 无就新增
    this.partnerId = this.getJump('companyId');
    this.partnerOrgId = this.getJump('partnerOrgId');
    if (this.partnerId) {
      this.edit = true;
    }

    // 清除缓存
    // this.clearKeepAlive('serviceCompany');
  },
  methods: {
    // 初始化
    nextStep: function (num) {
      this.clearKeepAlive('serviceCompany');
      if (this.tabActive === 1 && this.funcView.partner_company_simple) {
        this.tabActive = 3;
        return;
      }
      this.tabActive = num;
    },
    previous: function () {
      if (this.tabActive === 3 && this.funcView.partner_company_simple) {
        this.tabActive = 1;
        return;
      }
      this.tabActive = --this.tabActive;
    },
    // 编辑的时候点击步骤
    changeStep: function (arg) {
      if (this.edit) {
        this.tabActive = arg.value;
      }
    },
    syncPartnerId: function (partnerId, partnerOrgId) {
      this.partnerId = partnerId;
      this.partnerOrgId = partnerOrgId;
    },
    // 完成跳转
    jumpOut: function () {
      this.clearTagByKeep('company_item');
      this.jump('/distributor/serviceCompany', {}, true);
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.company-addItem {
  height: 100%;
  position: relative;
  overflow: auto;
  .steps {
    position: absolute;
    left: 0;
    top: 0;
    width: 220px;
    bottom: 0;
    background-color: #f9f9fd;
    .title {
      height: 70px;
      line-height: 70px;
      padding-left: 18px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(57, 70, 104, 1);
      .icon {
        color: #0d9ae0;
        // color: $main-color;
        font-size: 13px;
        margin-right: 10px;
      }
    }
  }
  .warpper {
    background-color: #ffffff;
    margin-left: 220px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    min-width: 1200px;
    .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .content-box {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      }
      .btn-group {
        border-top: 1px solid #eef2f8;
        padding: 16px 0 16px 24px;
        height: 60px;
        z-index: 1;
        -webkit-box-flex: 0;
        flex: 0 0 60px;
      }
    }
  }
}
// 步骤条
.steps {
  display: flex;
  flex: 0 0 220px;
  padding: 20px 0;
  overflow: hidden;
  flex-direction: column;
  .steps-item {
    flex: 1;
    .steps-item-head {
      position: relative;
      width: 100%;
      color: #8c8c8c;
      border-color: #8c8c8c;
      text-align: center;
      .line {
        position: relative;
        border-color: inherit;
        background-color: #d3d3d3;
        width: 100%;
        .line-left {
          left: 0;
          // right: -50%;
          height: 2px;
          top: 11px;
          position: absolute;
          border-color: inherit;
          background-color: #d3d3d3;
          background-color: inherit;
          width: 50%;
        }
        .line-rigth {
          // left: 50%;
          left: 50%;
          height: 2px;
          top: 11px;
          position: absolute;
          border-color: inherit;
          background-color: #d3d3d3;
          background-color: inherit;
          width: 50%;
        }
      }
      .icon {
        position: relative;
        z-index: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        background: #eff0f3;
        transition: 0.15s ease-out;
        border-radius: 50%;
        border: 1px solid;
        border-color: inherit;
        color: #999;
      }
    }
    .steps-item-main {
      text-align: center;
      .title {
        margin-top: 15px;
        color: #999;
      }
    }
  }
  .steps-item.on {
    flex: 1;
    .steps-item-head {
      color: #00afff;
      border-color: #00afff;
      .line {
        background-color: #00afff;
      }
      .icon {
        background: #00afff;
        color: #fff;
      }
    }
    .steps-item-main {
      text-align: center;
      .title {
        margin-top: 15px;
        color: #999;
      }
    }
  }

  .steps-item:first-of-type {
    .line {
      .line-left {
        display: none;
      }
    }
  }
  .steps-item:last-of-type {
    .line {
      .line-rigth {
        display: none;
      }
    }
  }
}
</style>
